<template>
	<div class="kefu-com">
		<div class="kefu-ask">咨询客服</div>
		<span>服务由小鲲车服提供</span>
	</div>
</template>
<script>
export default {
	data () {
		return {

		}
	}
}
</script>
<style lang="less" scoped>
.kefu-com {
	height: 2.6rem;
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-direction: column;
	margin: 2.2rem 0;
	.kefu-ask {
		width: 4.4rem;
		height: 1.5rem;
		line-height: 1.5rem;
		padding-left: 30px;
		border-radius: .9rem;
		position: relative;
		border:1px solid rgba(221,221,221,1);
		margin-bottom: 5px;
		font-size: 12px;
		color: #6D798B;
		&::before {
			content: '';
			position: absolute;
			width: 16px;
			height: 16px;
			background: url(../imgs/image/kefu.png) no-repeat;
			background-size: 100%;
			left: .6rem;
			top: 4px;
		}
	}
	span {
		color: #BEBEBE;
		font-size: 12px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/kefu.vue